import cn from 'classnames';
import { isNil } from 'lodash';
import React from 'react';
import { Skeleton } from 'antd';

import Chip from '@/comp/Chip';

import { ActionCountDetailsContainer } from './styled';

interface ActionCountDetailsProps {
  actionCount: number;
  value: string;
  label: string;
  actionCountClassName?: string;
  chipClassName?: string;
  rejectedAmount?: number;
  isLoading?: boolean;
}

const ActionCountDetails = ({
  actionCount,
  value,
  label,
  actionCountClassName,
  chipClassName,
  rejectedAmount,
  isLoading,
}: ActionCountDetailsProps) => {
  return (
    <ActionCountDetailsContainer>
      <Skeleton
        active
        loading={isLoading}
        paragraph={{ rows: 1, width: 40 }}
        title={false}
        rootClassName="action-count-details-skeleton"
      >
        <span data-action-count={actionCount ?? 0} className={cn('action-count', actionCountClassName ?? '')}>
          {actionCount ?? 'N/A'}
          <span className="action-rejected"> {!isNil(rejectedAmount) && `(${rejectedAmount})`} </span>
        </span>
      </Skeleton>
      <Skeleton
        active
        loading={isLoading}
        paragraph={false}
        title={{ width: 100 }}
        rootClassName="action-count-chip-skeleton"
      >
        <Chip title={value} className={cn('chip', chipClassName ?? '')} />
      </Skeleton>
      <span className="label">{label}</span>
    </ActionCountDetailsContainer>
  );
};

export default ActionCountDetails;
